// Cloudflare Turnstile, loaded only for sites that configure a site key.
// Renders into a light-DOM element so the challenge can show inside the chat
// (through a slot) when Cloudflare needs the visitor to click.

import { TURNSTILE_ACTION } from "../../shared/protocol";

interface TurnstileApi {
  render(el: HTMLElement, options: Record<string, unknown>): string;
  remove(id: string): void;
}

let loading: Promise<TurnstileApi> | undefined;

function load(): Promise<TurnstileApi> {
  loading ??= new Promise<TurnstileApi>((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    script.async = true;
    script.onload = () => resolve((window as unknown as { turnstile: TurnstileApi }).turnstile);
    script.onerror = () => {
      loading = undefined;
      reject(new Error("Turnstile failed to load"));
    };
    document.head.appendChild(script);
  });
  return loading;
}

export async function turnstileToken(siteKey: string, container: HTMLElement): Promise<string> {
  const turnstile = await load();
  return new Promise((resolve, reject) => {
    const id = turnstile.render(container, {
      sitekey: siteKey,
      action: TURNSTILE_ACTION,
      appearance: "interaction-only",
      callback: (token: string) => {
        resolve(token);
        setTimeout(() => turnstile.remove(id));
      },
      "error-callback": () => {
        reject(new Error("Turnstile challenge failed"));
        setTimeout(() => turnstile.remove(id));
      },
    });
  });
}
